/**
 * Comparison operators for level filtering
 */
export const COMPARISON_OPERATORS = {
  GTE: 'gte',
  EQ: 'eq', 
  LTE: 'lte'
};

/**
 * Human-readable labels for comparison operators
 */
export const COMPARISON_OPERATOR_LABELS = {
  [COMPARISON_OPERATORS.GTE]: 'Greater than or equal to',
  [COMPARISON_OPERATORS.EQ]: 'Equal to',
  [COMPARISON_OPERATORS.LTE]: 'Less than or equal to'
};

/**
 * Array of comparison operators with their labels for use in dropdowns
 */
export const COMPARISON_OPERATOR_OPTIONS = [
  {
    value: COMPARISON_OPERATORS.LTE,
    label: COMPARISON_OPERATOR_LABELS[COMPARISON_OPERATORS.LTE]
  },
  {
    value: COMPARISON_OPERATORS.EQ,
    label: COMPARISON_OPERATOR_LABELS[COMPARISON_OPERATORS.EQ]
  },
  {
    value: COMPARISON_OPERATORS.GTE,
    label: COMPARISON_OPERATOR_LABELS[COMPARISON_OPERATORS.GTE]
  }
];

/**
 * Default comparison operator
 */
export const DEFAULT_COMPARISON_OPERATOR = COMPARISON_OPERATORS.EQ; 